<template>
  <!-- 弹窗-手动添加黑名单会员 -->
  <y-dialog
    title="手动添加"
    :visible="isShowDialog"
    width="640px"
    :before-close="cancelBtn"
    @close="cancelBtn"
  >
    <el-form ref="form" :model="form" label-width="110px" size="small">
      <el-form-item required label="添加会员方式：">
        <el-radio-group v-model="form.type">
          <el-radio :label="1">全渠道会员ID</el-radio>
          <el-radio :label="2">平台账号添加</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label=" " label-width="110px" class="id-item">
        <!-- 平台账号添加：先选平台，再输入账号 -->
        <div class="id-col" v-if="form.type === 2">
          <el-select
            v-model="form.platform"
            class="platform-select"
            placeholder="请选择平台"
          >
            <el-option
              v-for="item in platformOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div class="id-row">
            <el-input
              v-model="form.inputStr"
              :placeholder="idPlaceholder"
              clearable
              @keyup.enter.native="handleAddId"
              maxlength="50"
            ></el-input>
            <y-button type="blue" class="add-btn" @click="handleAddId"
              >添加</y-button
            >
          </div>
        </div>
        <!-- 全渠道会员ID添加 -->
        <div class="id-row" v-else>
          <el-input
            v-model="form.inputStr"
            :placeholder="idPlaceholder"
            clearable
            @keyup.enter.native="handleAddId"
          ></el-input>
          <y-button type="blue" class="add-btn" @click="handleAddId"
            >添加</y-button
          >
        </div>
        <!-- 已添加的会员，逐个展示、可删除 -->
        <div class="id-tags" v-if="form.memberList.length">
          <el-tag
            v-for="(item, index) in form.memberList"
            :key="item"
            closable
            @close="removeId(index)"
            >{{ item }}</el-tag
          >
        </div>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="6"
          maxlength="100"
          show-word-limit
          placeholder="请输入备注，如恶意薅积分等"
        ></el-input>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <y-button @click="cancelBtn">取消</y-button>
      <y-button type="blue" :loading="submitLoading" @click="submitBtn"
        >确定</y-button
      >
    </template>
  </y-dialog>
</template>

<script>
import { createMemberBlacklist } from "@/api/memberMessageSystem";
export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        type: 1, // 添加会员方式：1 全渠道会员ID 2 平台账号添加
        platform: 1, // 平台账号添加时的平台：1 淘宝 2 京东 5 抖音
        inputStr: "", // 输入框内容，点击「添加」后进 memberList
        memberList: [], // 已添加的会员ID/账号，最多 10 个
        remark: "", // 备注，最多 100 字
      },
      platformOptions: [
        { label: "淘宝", value: 1 },
        { label: "京东", value: 2 },
        { label: "抖音", value: 5 },
      ],
      submitLoading: false,
    };
  },
  computed: {
    // 两种添加方式对应不同的输入提示
    idPlaceholder() {
      return this.form.type === 1
        ? '请输入全渠道会员ID，多个ID以英文","分隔，最多支持输入10个，点击添加保存'
        : "请输入平台账号后添加保存";
    },
  },
  created() {
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo || {};
  },
  watch: {
    // 切换添加方式时清空已填内容，避免会员ID和平台账号混在一起
    "form.type"() {
      this.form.inputStr = "";
      this.form.memberList = [];
    },
  },
  methods: {
    // 把输入框里的内容解析后追加到已添加列表
    handleAddId() {
      const text = (this.form.inputStr || "").trim();
      if (!text) {
        this.$message.warning(
          `请输入${this.form.type === 1 ? "会员ID" : "平台账号"}`
        );
        return;
      }
      // 支持英文逗
      const ids = text
        .split(/[,]/)
        .map((item) => item.trim())
        .filter(Boolean);
      if (!ids.length) {
        this.$message.warning(
          `请输入${this.form.type === 1 ? "会员ID" : "平台账号"}`
        );
        return;
      }
      const list = [...this.form.memberList];
      ids.forEach((id) => {
        if (!list.includes(id)) {
          list.push(id);
        }
      });
      if (list.length > 10) {
        this.$message.warning("最多支持添加10个");
        return;
      }
      this.form.memberList = list;
      this.form.inputStr = "";
    },
    // 删除已添加的某一项
    removeId(index) {
      this.form.memberList.splice(index, 1);
    },
    // 取消
    cancelBtn() {
      this.$emit("close");
    },
    // 确定：先把输入框里没点「添加」的内容合并进来，再提交
    submitBtn() {
      if (this.submitLoading) return;
      if (!this.form.memberList.length) {
        this.$message.warning("添加会员方式不能为空");
        return;
      }
      // 参数与接口文档对齐：type 决定用 memberId 还是 platform + platformUserId
      const params = {
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        type: this.form.type,
        remark: this.form.remark,
      };
      if (this.form.type === 1) {
        // 全渠道会员ID：多个以英文逗号拼接
        params.memberId = this.form.memberList.join(",");
      } else {
        // 平台用户ID：需要平台 + 账号
        params.platform = this.form.platform;
        params.platformUserId = this.form.memberList.join(",");
      }
      this.submitLoading = true;
      createMemberBlacklist(params)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("添加成功");
            this.$emit("success");
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.id-col {
  display: flex;
  flex-direction: column;

  // 与下方输入框右对齐：右侧留出「添加」按钮的宽度（72px）和间距（12px）
  .platform-select {
    align-self: stretch;
    margin-right: 84px;
    margin-bottom: 12px;
  }
}

.id-row {
  display: flex;
  align-items: center;

  .add-btn {
    flex-shrink: 0;
    margin-left: 12px;

    :deep(button) {
      width: 72px;
    }
  }
}

.id-tags {
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;

  .el-tag {
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
</style>
